// src/services/statisticsService.js
import { API_ENDPOINTS, apiClient } from './api';
import { cacheService } from './cacheService';

const CACHE_KEY_EMPLOYEES = 'employees_statistics';
const CACHE_KEY_DASHBOARD = 'dashboard_summary';
const CACHE_KEY_EXPIRED_BY_COURSE = 'expired_by_course';
const CACHE_KEY_EXPIRING_IN_MONTH = 'expiring_in_month';
const CACHE_KEY_EXPIRING_IN_TWO_MONTHS = 'expiring_in_two_months';

// Увеличенное время кеширования
const STATS_TTL = 30 * 60 * 1000; // 30 минут

export const statisticsService = {
  /**
   * Получение статистики по сотрудникам
   */
  getEmployeesStatistics: async (forceRefresh = false) => {
    const cacheKey = cacheService.getCacheKey(CACHE_KEY_EMPLOYEES);
    
    if (!forceRefresh) {
      const cached = cacheService.get(cacheKey, STATS_TTL);
      if (cached) {
        console.log('Возвращаем закешированную статистику сотрудников');
        return cached;
      }
    }
    
    console.log('Запрашиваем статистику сотрудников с сервера');
    
    try {
      const response = await apiClient.get(API_ENDPOINTS.EMPLOYEES_STATISTICS);
      
      const normalizedData = {
        total: response.total || 0,
        compliant: response.compliant || 0,
        nonCompliant: response.nonCompliant || 0,
        compliancePercentage: response.compliancePercentage || 0,
        byPosition: response.byPosition || {}
      };
      
      cacheService.set(cacheKey, normalizedData);
      return normalizedData;
    } catch (error) {
      console.error('Ошибка при получении статистики сотрудников:', error);
      throw error;
    }
  },
  
  /**
   * Инвалидация кеша статистики сотрудников
   */
  invalidateEmployeesCache: () => {
    cacheService.invalidate(CACHE_KEY_EMPLOYEES);
  },
  
  /**
   * Инвалидация кеша сводки дашборда
   */
  invalidateDashboardCache: () => {
    cacheService.invalidate(CACHE_KEY_DASHBOARD);
  },
  
  /**
   * Инвалидация кеша просроченных обучений
   */
  invalidateExpiredByCourseCache: () => {
    cacheService.invalidate(CACHE_KEY_EXPIRED_BY_COURSE);
  },
  
  /**
   * Инвалидация кеша истекающих обучений (месяц)
   */
  invalidateExpiringInMonthCache: () => {
    cacheService.invalidate(CACHE_KEY_EXPIRING_IN_MONTH);
  },
  
  /**
   * Инвалидация кеша истекающих обучений (2 месяца)
   */
  invalidateExpiringInTwoMonthsCache: () => {
    cacheService.invalidate(CACHE_KEY_EXPIRING_IN_TWO_MONTHS);
  },
  
  /**
   * Получение полной статистики для главной страницы
   */
  getMainPageStatistics: async (forceRefresh = false) => {
    try {
      const [employeesStats, dashboardSummary, expiredByCourse, expiringInMonth, expiringInTwoMonths] = await Promise.all([
        statisticsService.getEmployeesStatistics(forceRefresh),
        statisticsService.getDashboardSummary(forceRefresh),
        statisticsService.getExpiredByCourse(forceRefresh),
        statisticsService.getExpiringInMonth(forceRefresh),
        statisticsService.getExpiringInTwoMonths(forceRefresh)
      ]);
      
      return {
        employees: employeesStats,
        dashboard: dashboardSummary,
        expiredByCourse: expiredByCourse,
        expiringInMonth: expiringInMonth,
        expiringInTwoMonths: expiringInTwoMonths
      };
    } catch (error) {
      console.error('Ошибка при получении полной статистики:', error);
      throw error;
    }
  }
};

export default statisticsService;